<template>
	<div id="delete-preset-modal" class="modal-new hidden">
		<svg class="btn-close-modal" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
			<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>
		<span class="title">Delete Preset</span>
		<p class="description">
			Are you sure you want to delete preset: <br />"<span>{{ stripTimestampAndExtension(preset.name) }}</span
			>"?
		</p>
		<div class="buttons-continer">
			<button @click="onConfirm" type="button" class="modal-btn --primary --delete">Delete</button>
			<button @click="onCancel" type="button" class="modal-btn --cancel">Cancel</button>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import FilenameMixin from "@/mixins/Filename";

export default {
	mixins: [FilenameMixin],
	computed: {
		...mapState("UserFiles", ["preset"]),
	},
	methods: {
		async onConfirm() {
			window.UI.hideModal();
			await this.$store.dispatch("UserFiles/deleteUserFile", this.preset.id).then(() => {
				this.$store.dispatch("UserFiles/fetchPresets");
				window.UI.message.activate(`Preset deleted successfully`);
			});
		},
		onCancel() {
			window.UI.hideModal();
		},
	},
};
</script>

<style></style>
